import { Box, BoxProps } from "@mui/material";
import { TablePlaceHolder } from "@app/components/PlaceHolder";
import {
  SimulationBehaviorCash,
  SimulationBehaviorEquity,
  SimulationBehaviorFixedIncomeSpread,
  useAssetClassesSimulationBehaviorCashListQuery,
  useAssetClassesSimulationBehaviorCashUpdateMutation,
  useAssetClassesSimulationBehaviorEquityListQuery,
  useAssetClassesSimulationBehaviorEquityUpdateMutation,
  useAssetClassesSimulationBehaviorFixedIncomeSpreadListQuery,
  useAssetClassesSimulationBehaviorFixedIncomeSpreadUpdateMutation,
} from "@app/api/carApi.generated";
import { CarNumberFieldDelayed } from "@app/components/NumberField";
import { CarTextFieldDelayed } from "@app/components/Inputs";

interface SimulationModelsBehaviorStaticEquityProps {
  assetClassId: string;
  sx?: BoxProps["sx"];
}

export const SimulationModelsBehaviorStaticEquity = (
  props: SimulationModelsBehaviorStaticEquityProps,
) => {
  const data = useAssetClassesSimulationBehaviorEquityListQuery({
    id: "",
  });

  const [updateMut] = useAssetClassesSimulationBehaviorEquityUpdateMutation();

  const item = data.data?.find((be) =>
    be.assetclasslevel4_set?.includes(props.assetClassId),
  );

  const updateItem = (value: SimulationBehaviorEquity) => {
    updateMut({
      id: value.id ?? "",
      simulationBehaviorEquity: value,
    });
  };
  return (
    <Box sx={{ ...props.sx, display: "flex", flexDirection: "column" }}>
      <TablePlaceHolder isLoading={data.isLoading} rows={8}>
        {item && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "180px 180px",
              columnGap: 11,
              rowGap: 5,
              ".MuiInputBase-root": {
                backgroundColor: "white",
              },
            }}
          >
            <CarNumberFieldDelayed
              label="Static Model Calculated Mu"
              decimalPlaces={10}
              value={item.static_model_calculated_mu}
              onChange={(static_model_calculated_mu) =>
                updateItem({
                  ...item,
                  static_model_calculated_mu: static_model_calculated_mu ?? 0,
                })
              }
            />
            <CarNumberFieldDelayed
              label="Volatility (Sigma)"
              decimalPlaces={10}
              value={item.static_model_sigma}
              onChange={(static_model_sigma) =>
                updateItem({
                  ...item,
                  static_model_sigma: static_model_sigma ?? 0,
                })
              }
            />
            <CarNumberFieldDelayed
              label="Static Model Mu Override"
              decimalPlaces={10}
              value={item.static_model_mu_override}
              onChange={(static_model_mu_override) =>
                updateItem({
                  ...item,
                  static_model_mu_override: static_model_mu_override ?? 0,
                })
              }
            />
            <div />
            <CarTextFieldDelayed
              label="Static Model Mu Override Rationale"
              sx={{ gridColumn: "1 / span 2" }}
              fullWidth
              multiline
              rows={5}
              value={item.static_model_mu_override_rationale}
              onChange={(static_model_mu_override_rationale) =>
                updateItem({
                  ...item,
                  static_model_mu_override_rationale,
                })
              }
            />
          </Box>
        )}
      </TablePlaceHolder>
    </Box>
  );
};
